import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMall: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="mall, store, shop, business"><path fillRule="evenodd" clipRule="evenodd" d="M2 4.75C2 4.33579 2.33579 4 2.75 4H21.25C21.6642 4 22 4.33579 22 4.75V19.25C22 19.6642 21.6642 20 21.25 20H2.75C2.33579 20 2 19.6642 2 19.25V4.75ZM16 18.5V11.25C16 11.1119 15.8881 11 15.75 11H12.75V18.5H16ZM11.25 18.5V11H8.25C8.11193 11 8 11.1119 8 11.25V18.5H11.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconMall;
